export const constants = {
  redirectTo: "redirectTo",
  connectionkey: "filecatalystExpress.key",
  oidcClientId: "oidcClientId",
  fcloginPagePath: "fcloginpath",
  fcerrorparam: "fcerr",
  nonceCookieName: (oauthType) => {
    return getNonceCookieName(oauthType);
  },
};

function getNonceCookieName(oauthType) {
  let cookieName = "";
  switch (oauthType) {
    case "Okta":
      cookieName = "okta-oauth-nonce";
      break;
    default:
      cookieName = "okta-oauth-nonce";
      break;
  }
  return cookieName;
}
